import { tv } from '@change/ds-utils';

export const pageContainer = tv({
	base: 'bg-background-base flex min-h-screen flex-col',
});

export const header = tv({
	base: 'border-stroke-weaker bg-background-base w-full border-b',
});

export const headerContainer = tv({
	base: 'container flex h-[60px] items-center py-3',
});

export const headerTitle = tv({
	base: 'text-typography-strong ml-2.5',
});

export const contentContainer = tv({
	base: 'container flex flex-1 gap-12 py-12 lg:justify-between',
});

export const formSection = tv({
	base: 'flex w-full max-w-[604px] flex-col gap-8 lg:gap-6',
});

export const previewSection = tv({
	base: 'hidden w-full max-w-[487px] flex-col lg:flex',
});
